module.exports = __webpack_public_path__ + "static/13-6b4016c8017d00e559965f398043a66c.png";